import React from 'react';
import styled from 'astroturf/react';
import { ButtonLink } from 'js/design_system/link/ButtonLink';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import routes from 'js/core_pre_webpack/routes';
import { useInBreakpoints } from 'js/design_system/hooks/useBreakpoint';
import _Banner from "PodcastLibraryProfileBanner-Banner.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_library/PodcastLibraryProfileBanner.tsx?styleId=Banner";
import _Content from "PodcastLibraryProfileBanner-Content.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_library/PodcastLibraryProfileBanner.tsx?styleId=Content";
import _HeadingRow from "PodcastLibraryProfileBanner-HeadingRow.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_library/PodcastLibraryProfileBanner.tsx?styleId=HeadingRow";
import _Icon from "PodcastLibraryProfileBanner-Icon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_library/PodcastLibraryProfileBanner.tsx?styleId=Icon";
import _Heading from "PodcastLibraryProfileBanner-Heading.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_library/PodcastLibraryProfileBanner.tsx?styleId=Heading";
import _Subtext from "PodcastLibraryProfileBanner-Subtext.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_library/PodcastLibraryProfileBanner.tsx?styleId=Subtext";
import _ButtonContainer from "PodcastLibraryProfileBanner-ButtonContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_library/PodcastLibraryProfileBanner.tsx?styleId=ButtonContainer";


const PodcastLibraryIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_4977_23820"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4977_23820)">
      <path
        d="M4 22C3.71667 22 3.47917 21.9042 3.2875 21.7125C3.09583 21.5208 3 21.2833 3 21V7.05C3 6.8 3.05 6.5875 3.15 6.4125C3.25 6.2375 3.41667 6.1 3.65 6L13.65 2C13.9833 1.86667 14.2917 1.9125 14.575 2.1375C14.8583 2.3625 15 2.65 15 3V6H16C16.2833 6 16.5208 6.09583 16.7125 6.2875C16.9042 6.47917 17 6.71667 17 7V10H15V8H5V20H10.175L12.175 22H4ZM9 6H13V4.45L9 6ZM17 22C15.6167 22 14.4375 21.5125 13.4625 20.5375C12.4875 19.5625 12 18.3833 12 17C12 15.6167 12.4875 14.4375 13.4625 13.4625C14.4375 12.4875 15.6167 12 17 12C18.3833 12 19.5625 12.4875 20.5375 13.4625C21.5125 14.4375 22 15.6167 22 17C22 18.3833 21.5125 19.5625 20.5375 20.5375C19.5625 21.5125 18.3833 22 17 22ZM15.75 19.5L19.75 17L15.75 14.5V19.5Z"
        fill="white"
      />
    </g>
  </svg>
);

const Banner = /*#__PURE__*/styled("div", null, {
  displayName: "Banner",
  styles: _Banner
});

const Content = /*#__PURE__*/styled("div", null, {
  displayName: "Content",
  styles: _Content
});

const HeadingRow = /*#__PURE__*/styled("div", null, {
  displayName: "HeadingRow",
  styles: _HeadingRow
});

const Icon = /*#__PURE__*/styled(PodcastLibraryIcon, null, {
  displayName: "Icon",
  styles: _Icon
});

const Heading = /*#__PURE__*/styled("div", null, {
  displayName: "Heading",
  styles: _Heading
});

const Subtext = /*#__PURE__*/styled("p", null, {
  displayName: "Subtext",
  styles: _Subtext
});

const ButtonContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ButtonContainer",
  styles: _ButtonContainer
});

export const PodcastLibraryProfileBanner: React.FC = () => {
  const isMobile = useInBreakpoints(['small', 'medium']);

  return (
    <ImpressionWatcher source="podcast_lib.profile.banner">
      <Banner>
        <Content>
          <HeadingRow>
            <Icon />
            <Heading>Discover podcast library</Heading>
          </HeadingRow>
          <Subtext>Listen to paper insights in minutes, not hours</Subtext>
        </Content>
        <ButtonContainer>
          <ImpressionWatcher source="podcast_lib.profile.banner-browse-button">
            <ButtonLink
              href={routes.podcast_library_url()}
              size="xs"
              iconRight="arrow_forward"
              fullWidth={isMobile}
            >
              Browse podcast library
            </ButtonLink>
          </ImpressionWatcher>
        </ButtonContainer>
      </Banner>
    </ImpressionWatcher>
  );
};
